const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:5000',
    apiURL: 'http://localhost:5000/api'
  },
  staging: {
    baseURL: 'https://hmwkstudio-api.pbaldacimjr.workers.dev',
    apiURL: 'https://hmwkstudio-api.pbaldacimjr.workers.dev/api'
  },
  production: {
    baseURL: 'https://hmwkstudio-api-prod-production.pbaldacimjr.workers.dev',
    apiURL: 'https://hmwkstudio-api-prod-production.pbaldacimjr.workers.dev/api'
  }
};

// Determinar o ambiente atual
const getEnvironment = () => {
  // Se existe REACT_APP_API_URL definida, usar ela
  if (process.env.REACT_APP_API_URL) {
    return 'staging'; // Consideramos que se há API_URL definida, é staging/homolog
  }
  
  // Se está em desenvolvimento (npm start)
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  
  // Se está em produção (npm run build)
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_ENVIRONMENT || 'production';
  }
  
  return 'development';
};

const currentEnv = getEnvironment();

// Configuração atual baseada no ambiente
const config = {
  environment: currentEnv,
  baseURL: process.env.REACT_APP_API_URL 
    ? process.env.REACT_APP_API_URL.replace('/api', '')
    : API_CONFIG[currentEnv].baseURL,
  apiURL: process.env.REACT_APP_API_URL || API_CONFIG[currentEnv].apiURL
};

export default config; 